export default __webpack_public_path__ + "static/media/p21.50cc5a03.jpg";